// extracted by mini-css-extract-plugin
export default {"form":"style_form__yYk32","form_wrapper":"style_form_wrapper__u06Ha","disabled":"style_disabled__Nb-3r","input":"style_input__FJtsC","bg":"style_bg__eCNay"};